module.exports = __webpack_public_path__ + "static/img/14002010.6edec9e2.png";